import React, { useReducer, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col
} from 'reactstrap';
import { v4 } from 'uuid';

import { initialState, reducer } from './utils';
import { modalPropTypes, modalDefaultProps } from './propTypes';

import ButtonCustom from '../ButtonCustom';

import './Modal.css';

function ModalCustom(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (props.openByDefault) {
      dispatch({ type: 'TOGGLE' });
    }
  }, [props.openByDefault]);

  const toggle = () => {
    if (state.showModal) {
      dispatch({ type: 'RESET_MODAL_DATA' });
      props.resetAction();
      return;
    }
    dispatch({ type: 'TOGGLE' });
  };

  const {
    modalTitle,
    modalBody,
    showPrimaryButton,
    textPrimaryButton,
    showSecondaryButton,
    textSecondaryButton,
    returnFocus
  } = props;

  const finalBodyMessage = (typeof modalBody === 'string') ? [modalBody] : modalBody;

  function handlePrimaryAction() {
    props.funcPrimaryButton();
    toggle();
  }

  function handleSecondaryAction() {
    props.funcSecondaryButton();
    toggle();
  }

  function modalPositionFixIe() {
    const allNodes = document.querySelectorAll('body > div');

    if (allNodes.length === 0) return;

    const lastElement = allNodes[allNodes.length - 1];

    if (lastElement) {
      lastElement.style.position = '';
    }
  }

  const maxTabIdex = '99';
  return (
    <div>
      <Modal
        onOpened={modalPositionFixIe}
        tabIndex={maxTabIdex}
        returnFocusAfterClose={returnFocus}
        isOpen={state.showModal}
        toggle={toggle}
      >
        <ModalHeader tabIndex={maxTabIdex} toggle={toggle} data-test-id="cerrar-popup">
          {modalTitle}
        </ModalHeader>
        <ModalBody>
          {finalBodyMessage.map(message => <p key={`${v4()}`}>{message}</p>)}
        </ModalBody>
        <ModalFooter>
          <Row className="auto-margin justify-content-end w-100">
            {showSecondaryButton && (
              <Col sm="3" className="no-padding-right">
                <ButtonCustom
                  tabIndex={maxTabIdex}
                  dataTestLabel="boton-accion-2"
                  label={textSecondaryButton}
                  colorClass="cancel-bttn"
                  clickAction={handleSecondaryAction}
                />
              </Col>
            )}
            {showPrimaryButton && (
              <Col sm="3" className="no-padding-right">
                <ButtonCustom
                  tabIndex={maxTabIdex}
                  dataTestLabel="boton-accion-1"
                  label={textPrimaryButton}
                  colorClass="continue-bttn"
                  clickAction={handlePrimaryAction}
                />
              </Col>
            )}
          </Row>
        </ModalFooter>
      </Modal>
    </div>
  );
}

ModalCustom.propTypes = modalPropTypes;

ModalCustom.defaultProps = modalDefaultProps;

export default ModalCustom;
